import React, { useState, useEffect } from 'react';
import EmployeeSuggest from './EmployeeSuggest';
import { API_BASE_URL } from '../config';
import { Handle } from '@xyflow/react';

export default function CustomNode({ id, data }) {
  const [editing, setEditing] = useState(false);
  const [departments, setDepartments] = useState([]);
  const nodeData = data || {};
  const assignee = nodeData.assignee || null;
  const type = nodeData.type || 'employee';
  const department = nodeData.department || '';

  useEffect(() => {
    if (type === 'department' && departments.length === 0) {
      console.log('Fetching departments...');
      fetch(`${API_BASE_URL}/api/departments`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      })
        .then(res => res.json())
        .then(setDepartments)
        .catch(console.error);
    }
  }, [type, departments.length]);

  const handleTypeChange = (newType) => {
    nodeData.onUpdate && nodeData.onUpdate(id, { type: newType, assignee: null, department: '' });
  };

  const handleDepartmentChange = (e) => {
    nodeData.onUpdate && nodeData.onUpdate(id, { department: e.target.value });
  };

  const isStart = data.label === 'Start';
  const formFields = Array.isArray(nodeData.formFields) ? nodeData.formFields : [];
  const skipWhen = nodeData.skipWhen || null;
  const skipField = skipWhen ? formFields.find(f => f.id === skipWhen.fieldId) : null;
  const skipValues = (skipWhen && Array.isArray(skipWhen.values)) ? skipWhen.values : [];
  const skipFieldOptions = skipField && Array.isArray(skipField.options) ? skipField.options : [];

  const handleLabelChange = (e) => {
    nodeData.onUpdate && nodeData.onUpdate(id, { label: e.target.value });
  };

  const updateSkipWhen = (next) => {
    nodeData.onUpdate && nodeData.onUpdate(id, { skipWhen: next });
  };

  const handleSkipFieldChange = (fieldId) => {
    updateSkipWhen(fieldId ? { fieldId, values: [] } : null);
  };

  const toggleSkipValue = (value, checked) => {
    const next = checked ? [...skipValues, value] : skipValues.filter(v => v !== value);
    updateSkipWhen({ fieldId: skipWhen.fieldId, values: next });
  };

  return (
    <div style={{
      padding: 10,
      minWidth: 180,
      background: '#fff',
      border: '1px solid rgba(0,0,0,.12)',
      borderRadius: 6,
      boxShadow: '0 6px 14px rgba(0,0,0,.06)'
    }}>
      {data.label && data.label !== 'Start' && (
        <Handle type="target" position="top" style={{ background: '#555' }} />
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {editing && !isStart ? (
          <input
            type="text"
            value={nodeData.label || ''}
            onChange={handleLabelChange}
            onClick={(e) => e.stopPropagation()}
            style={{ fontWeight: 700, width: '100%', marginRight: 8, padding: 4, border: '1px solid #ddd', borderRadius: 4 }}
          />
        ) : (
          <div style={{ fontWeight: 700 }}>{nodeData.label || id}</div>
        )}
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="button-primary" onClick={() => setEditing(s => !s)}>Edit</button>
          {data.label && data.label !== 'Start' &&
            <button className="button-danger" onClick={() => nodeData.onDelete && nodeData.onDelete(id)}>Delete</button>
          }
        </div>
      </div>
      {editing && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Type</div>
          <select value={type} onChange={(e) => handleTypeChange(e.target.value)} style={{ width: '100%', padding: 4, border: '1px solid #ddd', borderRadius: 4 }}>
            <option value="employee">Employee</option>
            <option value="general">General</option>
            <option value="department">Department</option>
            <option value="hod">Creator's HOD</option>
            <option value="hod_reportee">Reportee to Creator's HOD</option>
          </select>
        </div>
      )}
      {editing && Array.isArray(nodeData.formFields) && nodeData.formFields.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Editable Fields at this Stage</div>
          {nodeData.formFields.map(field => {
            const checked = (nodeData.editableFields || []).includes(field.id);
            return (
              <label key={field.id} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 4, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={(e) => {
                    const current = nodeData.editableFields || [];
                    const next = e.target.checked
                      ? [...current, field.id]
                      : current.filter(fid => fid !== field.id);
                    nodeData.onUpdate && nodeData.onUpdate(id, { editableFields: next });
                  }}
                />
                <span>{field.label}</span>
                <span style={{ color: '#999', fontSize: 11 }}>({field.type})</span>
              </label>
            );
          })}
        </div>
      )}
      {editing && !isStart && formFields.length > 0 && (
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Skip this stage when</div>
          <select
            value={skipWhen ? skipWhen.fieldId : ''}
            onChange={(e) => handleSkipFieldChange(e.target.value)}
            style={{ width: '100%', padding: 4, border: '1px solid #ddd', borderRadius: 4 }}
          >
            <option value="">Never skip</option>
            {formFields.map(f => <option key={f.id} value={f.id}>{f.label}</option>)}
          </select>
          {skipWhen && skipFieldOptions.length > 0 && (
            <div className="nowheel" style={{ marginTop: 6, maxHeight: 160, overflowY: 'auto', border: '1px solid #eee', borderRadius: 4, padding: 6 }}>
              {skipFieldOptions.map(opt => (
                <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 4, cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={skipValues.includes(opt)}
                    onChange={(e) => toggleSkipValue(opt, e.target.checked)}
                  />
                  <span>{opt}</span>
                </label>
              ))}
            </div>
          )}
          {skipWhen && skipFieldOptions.length === 0 && (
            <input
              type="text"
              value={skipValues[0] || ''}
              onChange={(e) => updateSkipWhen({ fieldId: skipWhen.fieldId, values: e.target.value ? [e.target.value] : [] })}
              placeholder="Value"
              style={{ width: '100%', marginTop: 6, padding: 4, border: '1px solid #ddd', borderRadius: 4 }}
            />
          )}
        </div>
      )}
      {!editing && skipWhen && skipValues.length > 0 && (
        <div style={{ marginTop: 8, padding: 6, fontSize: 12, color: '#7c2d12', background: '#fff7ed', border: '1px dashed #fdba74', borderRadius: 4 }}>
          Skipped when {skipField ? skipField.label : 'a removed field'} is {skipValues.join(' / ')}
        </div>
      )}
      <div style={{ marginTop: 8 }}>
        <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Assignee</div>
        {type === 'employee' && (
          assignee ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontWeight: 600 }}>{assignee.EmployeeName}</div>
                <div style={{ fontSize: 12, color: '#666' }}>{assignee.Empcode}</div>
              </div>
              <div style={{ marginLeft: 8 }}>
                <button className="button-muted" onClick={() => nodeData.onUpdate && nodeData.onUpdate(id, { assignee: null })}>Clear</button>
              </div>
            </div>
          ) : (
            <div>
              {editing && <EmployeeSuggest value={assignee ? assignee.EmployeeName : ''} onChange={(item) => nodeData.onUpdate && nodeData.onUpdate(id, { assignee: item })} placeholder={' Name or Empcode'} />}
              {!editing && <div onClick={() => setEditing(true)} style={{ padding: 8, color: '#999', border: '1px dashed #ddd', borderRadius: 4 }}>Click Edit to assign employee</div>}
            </div>
          )
        )}
        {type === 'general' && (
          <div style={{ padding: 8, color: '#666', fontStyle: 'italic' }}>Anyone can approve</div>
        )}
        {type === 'hod' && (
          <div style={{ padding: 8, color: '#0366d6', fontStyle: 'italic', border: '1px dashed #0366d6', borderRadius: 4 }}>Auto-assigned to creator's HOD</div>
        )}
        {type === 'hod_reportee' && (
          <div style={{ padding: 8, color: '#1f7a39', fontStyle: 'italic', border: '1px dashed #1f7a39', borderRadius: 4 }}>Auto-assigned to all direct reportees of creator's HOD</div>
        )}
        {type === 'department' && (
          department ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontWeight: 600 }}>{department}</div>
              <button className="button-muted" onClick={() => nodeData.onUpdate && nodeData.onUpdate(id, { department: '' })}>Clear</button>
            </div>
          ) : (
            <div>
              {editing && (
                <select value={department} onChange={handleDepartmentChange} style={{ width: '100%', padding: 4, border: '1px solid #ddd', borderRadius: 4 }}>
                  <option value="">Select Department</option>
                  {departments.map(dep => <option key={dep} value={dep}>{dep}</option>)}
                </select>
              )}
              {!editing && <div onClick={() => setEditing(true)} style={{ padding: 8, color: '#999', border: '1px dashed #ddd', borderRadius: 4 }}>Click Edit to assign department</div>}
            </div>
          )
        )}
      </div>
      <Handle type="source" position="bottom" style={{ background: '#555' }} />
    </div>
  );
}
